import { useState, useEffect } from "react";

import { RACE_SOURCES } from "../../api";

function LiveIndexPage() {
  const [races, setRaces] = useState([]);
  const [loaded, setLoaded] = useState(false);

  function fetchRaces() {
    // One request per configured backend. A source that fails or has no
    // live-races endpoint contributes nothing rather than breaking the page.
    Promise.all(
      RACE_SOURCES.map((source) =>
        fetch(source.base + "/rest/live-races")
          .then((response) => response.json())
          .then((data) => (Array.isArray(data) ? data.map((race) => ({ ...race, src: source.src })) : []))
          .catch(() => [])
      )
    ).then((lists) => {
      const merged = lists.flat();
      // Race ids don't collide between backends, so no dedupe needed.
      merged.sort((a, b) => (b.date ?? "").localeCompare(a.date ?? ""));
      setRaces(merged);
      setLoaded(true);
    });
  }

  useEffect(() => {
    fetchRaces();
    const interval = setInterval(fetchRaces, 60000);
    return () => clearInterval(interval);
  }, []);

  const live = races.filter((race) => race.status === "live");
  const completed = races.filter((race) => race.status !== "live");

  function raceRow(race) {
    return (
      <a
        key={race.id}
        href={"/?raceId=" + race.id + (race.src ? "&src=" + race.src : "")}
        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
      >
        <span>{race.name}</span>
        <span className="text-muted">{race.date}</span>
      </a>
    );
  }

  function section(title, items, badge) {
    if (items.length === 0) {
      return null;
    }
    return (
      <div className="mb-4">
        <h2 className="h5">
          {title}
          {badge}
        </h2>
        <div className="list-group">{items.map(raceRow)}</div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h1 className="mb-4">Liveresultat</h1>
      {section(
        "Pågående tävlingar",
        live,
        <span className="badge bg-danger ms-2">LIVE</span>
      )}
      {section("Nyligen avslutade", completed, null)}
      {loaded && races.length === 0 && (
        <p className="text-muted">Inga tävlingar just nu.</p>
      )}
    </div>
  );
}

export default LiveIndexPage;
